import React from "react";
import { useHistory } from "react-router-dom";
import Back from "../../assets/assets/back.svg";
import { PropTypes } from "prop-types";

const Docs = (props) => {
  const history = useHistory();

  const singleDoc = props.location.state;

  const reloadTab = () => {
    if (window.localStorage) {
      if (!localStorage.getItem("firstLoad")) {
        localStorage["firstLoad"] = true;
        window.location.reload();
      } else localStorage.removeItem("firstLoad");
    }
  };

  const goback = () => {
    history.push("/dashboard");
  };

  return (
    <div>
      <span
        className="iframe-back"
        data-testid="goback"
        onClick={() => goback()}
      >
        <img src={Back} alt="back" /> Back
      </span>
      <iframe
        data-testid="reload"
        onLoad={() => reloadTab()}
        src={singleDoc.link}
        width="100%"
        height="1000"
        title={singleDoc.name}
        name={singleDoc.name}
      ></iframe>
    </div>
  );
};

Docs.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      link: PropTypes.string,
      name: PropTypes.string,
    }),
  }),
};

export default Docs;
